export default __webpack_public_path__ + "static/list-block-1-bg-desktop-84291ec650abf878d88d67371b59143b.png";